import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService, AuthenticationService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { CollaboratorsService } from "app/modules/collaborators/collaborators.service";
import { environment } from "environments/environment";
import { jsPDF } from "jspdf";
import moment from "moment";
import { WorkdayReportService } from "../../workday-report.service";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-collaborators-by-provider-reports-list",
  templateUrl: "./collaborators-by-provider-reports-list.component.html",
  styleUrls: ["./collaborators-by-provider-reports-list.component.scss"],
})
export class CollaboratorsByProviderReportsListComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public contentHeader: IContentHeader;
  public reportsList: any = [];
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public categories: any = [];
  public selectedMonth: string = moment().format("M");
  public selectedYear: string = moment().format("YYYY");
  public statuses_labels: any;
  public searchStatus: number = 10;
  public byProviderFilter: number = 0;
  public availableMonths: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: any = [];
  public usersList: any = [];
  public selectedReport: any;
  public me: ICurrentUser;
  public reports: any = [];
  public available_working_days: Array<number> = [];
  public collaboratorList: any = [];
  public lastDayOfTheSelectedMonth: any = null;
  public totalWorkedHourMonthSelected: number = 0;
  public pageNumber: number = 0;

  constructor(
    public _workdayReportService: WorkdayReportService,
    public _utilService: UtilsService,
    public _userService: UserService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.WORKDAY_COLLABORATORS_REPORTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.WORKDAY_COLLABORATORS_REPORTS",
            isLink: false,
          },
        ],
      },
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const status = params.status;
      const month = params.month;
      const year = params.year;
      const page = params.page;

      if (!!searchKey && searchKey != 0) {
        this.searchKeyword = searchKey;
      }
      if (!!status && Number(status) >= 0 && Number(status) < 5) {
        this.searchStatus = Number(status);
      }

      if (!!month && Number(month) > 0 && Number(month) <= 12) {
        this.selectedMonth = month;
      }
      if (!!year && Number(year) > 0) {
        this.selectedYear = year;
      }
      if (!!page) {
        this.pageNumber = page;
      }
    });

    const currentYear = moment().format("YYYY");
    for (let i = 2022; i <= Number(currentYear); i++) {
      this.availableYears.push(String(i));
    }
    this.available_working_days = this._utilService.themeConfiguration.working_days; // Parametro gestito da configurazione per i giorni lavorativi
  }

  async ngOnInit() {
    this.me = await this._authenticationService.getCurrentUser();
    this.statuses_labels = await this._utilService.translate("STATUS");
    await this.loadReports();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadReports() {
    this.usersList = await this._collaboratorService.getCollaboratorList();
    this.reportsList = await this._workdayReportService.getList();

    this.reportsList.map((item: any) => {
      item.worked_hours = Number(item.worked_hours);
      item.extra_hours = Number(item.extra_hours);
    });

    this.usersList.map((item: any) => {
      item.reports = this.reportsList.filter((report: any) => report.user_hash == item.hash);
    });

    this.reportsFilterList();

    this._utilService.hideLoading();
  }

  reportsFilterList() {
    const filterForCollaborators = moment(`${this.selectedYear}-${(Number(this.selectedMonth)).toString().padStart(2, "0")}-01`).endOf('month');
    //Resetto la variabile
    this.totalWorkedHourMonthSelected = 0;
    let items: any = this.usersList.filter((item: any) => moment(item.create_date) < filterForCollaborators).sort((a: any, b: any) => (a.complete_name > b.complete_name ? 1 : -1));
    //Calcolo riferimento delle ore lavorative dell'anno e mese selezionati
    this.lastDayOfTheSelectedMonth = moment(`${this.selectedYear}-${this.selectedMonth.padStart(2, "0")}-01T22:00:00.000Z`, "YYYY-MM-DD")
      .endOf("month")
      .format("DD");
    for (let i = 1; i <= this.lastDayOfTheSelectedMonth; i++) {
      const currentDate = moment(`${this.selectedYear}-${this.selectedMonth.padStart(2, "0")}-${i}T22:00:00.000Z`, "YYYY-MM-D");
      let workingHours: number = this.available_working_days.includes(Number(currentDate.format("d"))) ? 8 : 0;
      this.totalWorkedHourMonthSelected += this._utilService.isHoliday(currentDate) ? 0 : workingHours;
    }
    items.map((user: any) => {
      if (user.reports && user.reports.length > 0) {
        user.currentReport = user.reports.filter((report: any) => report.month == Number(this.selectedMonth) && report.year == Number(this.selectedYear));
      }
      if ((user.currentReport && user.currentReport.length < 1) || (user.reports && user.reports.length < 1)) {
        user.currentReport = [
          {
            status: 4,
            worked_hours: 0,
            extra_hours: 0,
          },
        ];
      }
    });

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.complete_name.toLowerCase().includes(keywords) || item?.business_name?.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 5) {
      items = items.filter((item: any) => item.currentReport[0].status === Number(this.searchStatus));
    }
    if (this.byProviderFilter > 0) {
      if (this.byProviderFilter == 1) {
        items = items.filter((item: any) => item.type_name && item.type_name === "Da Fornitore");
      } else if (this.byProviderFilter == 2) {
        items = items.filter((item: any) => item.type_name && item.type_name !== "Da Fornitore");
      }
    }

    this.reports = items;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKeyword && this.searchKeyword.length >= 3) {
      url.searchParams.set("search", String(this.searchKeyword));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.searchStatus && this.searchStatus < 5 && this.searchStatus >= 0) {
      url.searchParams.set("status", String(this.searchStatus));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status");
      history.pushState({}, "", url);
    }

    if (!!this.selectedMonth && Number(this.selectedMonth) > 0 && Number(this.selectedMonth) <= 12) {
      url.searchParams.set("month", this.selectedMonth);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("month");
      history.pushState({}, "", url);
    }

    if (!!this.selectedYear && Number(this.selectedYear) > 0) {
      url.searchParams.set("year", this.selectedYear);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("year");
      history.pushState({}, "", url);
    }
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }

  async exportReportPDF(report_id: number) {
    this._utilService.showLoading();

    const report: any = await this._workdayReportService.get(report_id);

    // creo il nome con cui si salverà il file
    const fileName = report.complete_name + "-" + this.selectedMonth + "-" + this.selectedYear + ".pdf";

    const month: string = moment(this.selectedYear + "-" + this.selectedMonth.padStart(2, "0") + "-01").format("MMMM YYYY");

    // stampo il file
    let body: string =
      '<body style="margin: 0; padding: 0; box-sizing: border-box;">' +
      // stampo il nome e il mese
      '<div style="height: 35px;width: 420px; font-size: 12px; display: flex; margin-top:10px;">' +
      '<div style="width:100px">' +
      `<img src="${environment.CDN_URL}/site/templates/logo-nepta-header.png" alt="nepta" style="width: 100%">` +
      "</div>" +
      '<div style="margin-left: 20px; display: flex; flex-direction: column; line-height: 15px">' +
      '<span style="text-transform: capitalize; letter-spacing: normal; word-spacing: -.7ch">' +
      report.complete_name +
      "</span>" +
      '<span style="letter-spacing: normal; text-transform: capitalize; word-spacing: -.7ch;"> ' +
      month +
      "</span>" +
      "</div>" +
      "</div>" +
      // inizio della tabella
      '<div style="width:610px; height:60px; margin-top:20px; font-size:11px;display: flex; border-left:0.2px solid #cccccc;">';
    // inizializzo il mio contatore
    let i: number = 0;

    // variabile somma ore
    let sumWorkingHours: number = 0;

    const daysReport: any[] = Object.values(report.data).sort((a: any, b: any) => {
      a = moment(a.date, "YYYY-M-DD");
      b = moment(b.date, "YYYY-M-DD");
      return a > b ? 1 : a < b ? -1 : 0;
    });

    for (const data of daysReport) {
      let workedHours: number = data.working_hours;
      // se ci sono extra per le commesse li dobbiamo aggiungere
      for (const commission of data.commissions) {
        workedHours += commission.extra.hours_payroll || 0;
        workedHours += commission.extra.extra_km || 0;
      }
      // se ci sono extra per i costi di struttura li dobbiamo aggiungere
      for (const structure of data.structures) {
        workedHours += structure.extra.hours_payroll || 0;
        workedHours += structure.extra.extra_km || 0;
      }
      // capisco che giorno mi restituisce e ciclo
      let day = moment(data.date, "YYYY-M-D");
      body +=
        //stamperò la colonna contenente numero, giorno, festività, ora lavorata
        '<div style="text-align: center;width: ' +
        100 / daysReport.length +
        "%; height:100%; border-top: 0.2px solid #cccccc; border-right: 0.2px solid #cccccc; border-bottom: 0.2px solid #cccccc; display: flex;" +
        " flex-direction: column;" +
        " background-color:" +
        (day.day() == 6 || day.day() == 0 ? "#f3f3f3" : this._utilService.isHoliday(day.format("YYYY-MM-DD")) ? "#dcdcdc" : "#fff") +
        '">' +
        // numero giorno
        '<span style="width: 100%;height: 20px;letter-spacing: normal; margin: auto; border-bottom: 0.2px solid #cccccc">' +
        String(i + 1).padStart(2, "0") +
        "</span>" +
        // nome giorno
        '<span style="width: 100%;height: 20px;letter-spacing: normal; margin: auto; padding-top: 1px">' +
        (this._utilService.isHoliday(day.format("YYYY-MM-DD")) ? "-" : this._utilService.formatDate(day, "dd")) +
        "</span>" +
        // ore lavorate
        '<span style="width: 100%;height: 20px;margin: auto; border-top: 0.2px solid #cccccc">' +
        workedHours +
        "</span>" +
        "</div>";
      i++;
      sumWorkingHours += workedHours;
    }

    body +=
      "</div>" +
      '<div style="font-size: 10px; width:610px;margin: 10px 0 190px 0">' +
      '<span style="letter-spacing: normal; word-spacing: -.4ch;">Totale ore ' +
      sumWorkingHours +
      "</span>" +
      "</div>" +
      `<img src="${environment.CDN_URL}/site/templates/footer-documento.png" alt="nepta" style="width:610px;margin:0 auto;">` +
      "</body>";

    // genero l'oggetto contenete l'orientamento, l'unità di misura, e il formato'
    const doc = new jsPDF("l", "px", "a4");
    // faccio sparire il loading
    this._utilService.hideLoading();
    doc.html(body, {
      callback: function (docReturn) {
        // salvo il pdf
        docReturn.save(fileName);
      },
      x: 10,
      y: 10,
    });
  }

  setPage(pageInfo: any) {
    this.pageNumber = pageInfo.offset;
    const url = new URL(window.location.href);

    if (!!this.pageNumber && this.pageNumber >= 1) {
      url.searchParams.set("page", String(this.pageNumber));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("page");
      history.pushState({}, "", url);
    }
  }

  async generateReport(row: any) {
    await this._utilService
      .showSWALDeleteConfirmation({
        text: "ALERT.CONFIRM_GENERATE_WORKDAY_REPORT",
        confirmButtonText: "BTN_SUCCESS",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      })
      .then(async (result: any) => {
        if (result.value) {
          await this._utilService.showLoading();
          return this._utilService
            .basic_get(`/report/generate/${this.selectedMonth}/${this.selectedYear}/${row.hash}`)
            .then(async () => {
              await this._utilService.hideLoading();
              await this.loadReports();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_WORKDAY_REPORT" });
            })
            .catch(async (err: any) => {
              await this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_GENERATE_WORKDAY_REPORT" });
              console.error(err);
            });
        }
      });
  }
}
